// extracted by mini-css-extract-plugin
export var balloon = "SentMessage-module--balloon--31f72";
export var content = "SentMessage-module--content--af629";
export var isFirstMessage = "SentMessage-module--isFirstMessage--37fa6";
export var isLastMessage = "SentMessage-module--isLastMessage--515d6";
export var sentMessage = "SentMessage-module--sentMessage--9069e";
export var timestamp = "SentMessage-module--timestamp--b5621";